// #region generico
export const CARREGAMENTO = 'CARREGAMENTO';
export const BEGIN_API_CALL = 'BEGIN_API_CALL';
export const API_CALL_ERROR = 'API_CALL_ERROR';
export const CARREGA_CONFIGURACAO_SUCCESS_BACKGROUND =
    'CARREGA_CONFIGURACAO_SUCCESS_BACKGROUND';
export const ALERT = 'ALERT';
// #endregion

// #region Tabela
export const CARREGADO_DADOS_TABELA_SUCCESS = 'CARREGADO_DADOS_TABELA_SUCCESS';
export const ATUALIZA_LINHA_TABELA_SUCCESS = 'ATUALIZA_LINHA_TABELA_SUCCESS';
export const EXPORTA_DADOS_TABELA_SUCCESS = 'EXPORTA_DADOS_TABELA_SUCCESS';
// #endregion

// #region Usuario
export const CARREGA_USUARIO_SUCCESS = 'CARREGA_USUARIO_SUCCESS';
export const USUARIO_CRIADO_SUCCESS = 'USUARIO_CRIADO_SUCCESS';
export const USUARIO_EDITADO_SUCCESS = 'USUARIO_EDITADO_SUCCESS';
export const USER_IMPORT_SUCCESS = 'USER_IMPORT_SUCCESS';
// #endregion

// #region Login
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_CLEAN = 'LOGIN_CLEAN';
export const LOGIN_EXPIRADO = 'LOGIN_EXPIRADO';
export const LOGIN_NOVA_PERMISSOES = 'LOGIN_NOVA_PERMISSOES';
// #endregion

// #region Auditoria
export const CARREGA_AUDITORIA_SUCCESS = 'CARREGA_AUDITORIA_SUCCESS';
// #endregion

// #region Migalha
export const MIGALHA = 'MIGALHA';
// #endregion

// #region Mensagem
export const ENVIAR_MENSAGEM_SUCCESS = 'ENVIAR_MENSAGEM_SUCCESS';
// #endregion

export const MENU_STATE = 'MENU_STATE';

export const NOVO_FILTRO_STATE = 'NOVO_FILTRO_STATE';

// Avisos
export const CARREGA_AVISOS_SUCCESS = 'CARREGA_AVISOS_SUCCESS';

export const CARREGA_TREINAMENTOS_SUCCESS = 'CARREGA_TREINAMENTOS_SUCCESS';
export const CARREGA_SAUDE_SUCCESS = 'CARREGA_SAUDE_SUCCESS';
export const CARREGA_EQUIPAMENTOS_SUCCESS = 'CARREGA_EQUIPAMENTOS_SUCCESS';
export const CARREGA_STATUSTECNICOS_SUCCESS = 'CARREGA_STATUSTECNICOS_SUCCESS';
export const CARREGA_CONHECIMENTO_SUCCESS = 'CARREGA_CONHECIMENTO_SUCCESS';
export const ENVIAR_CONHECIMENTO_SUCCESS = 'ENVIAR_CONHECIMENTO_SUCCESS';

export const NOVO_FILTRO_MATRICULA_TECNICO_STATE =
    'NOVO_FILTRO_MATRICULA_TECNICO_STATE';

export const NOVO_FILTRO_NUMERO_BA_STATE = 'NOVO_FILTRO_NUMERO_BA_STATE';

export const NOVO_FILTRO_OS_BD_STATE = 'NOVO_FILTRO_OS_BD_STATE';

export const NOVO_FILTRO_STATE_CHANGE_COLOR = 'NOVO_FILTRO_STATE_CHANGE_COLOR';

export const NOVO_FILTRO_SELECT_PERIODO_ANTERIOR =
    'NOVO_FILTRO_SELECT_PERIODO_ANTERIOR';

export const ROTA_DETALHAR = 'ROTA_DETALHAR';
